import { ApplicationRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { rootReducer } from 'ChartApp/ts/apps/fund-chart/state/fund-chart.reducer';
import { ConfigModule } from 'Angular/config/config.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { SideMenuModule } from 'Angular/features/components/side-menu/side-menu.module';
import { ChartEditorHeaderModule } from 'ChartApp/ts/features/chart-editor-header/chart-editor-header.module';
import { ChartsSharedModule } from 'ChartApp/ts/features/charts-shared/charts-shared.module';
import { FundUniverseQuartileChartModule } from 'ChartApp/ts/features/fund-universe-quartile-chart/fund-universe-quartile-chart.module';
import { SecurityHeaderControlModule } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.module';
import { FundUniverseQuartileChartPageComponent } from './fund-universe-quartile-chart-page.component';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { getLogger } from 'Angular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ngrx/store";
export class FundUniverseQuartileChartPageModule {
    ngDoBootstrap(appRef) {
        appRef.bootstrap(SideMenuComponent);
        appRef.bootstrap(SecurityHeaderControlComponent);
        appRef.bootstrap(TopBarNavComponent);
        appRef.bootstrap(FundUniverseQuartileChartPageComponent);
    }
}
FundUniverseQuartileChartPageModule.ɵfac = function FundUniverseQuartileChartPageModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundUniverseQuartileChartPageModule)(); };
FundUniverseQuartileChartPageModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FundUniverseQuartileChartPageModule });
FundUniverseQuartileChartPageModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ChartEditorHeaderModule,
        ChartsSharedModule,
        ConfigModule,
        FormsModule,
        FundUniverseQuartileChartModule,
        NavigationModule,
        RouterModule.forRoot([], { useHash: true }),
        SecurityHeaderControlModule,
        SideMenuModule,
        StoreModule.forRoot({ reducers: rootReducer }, { metaReducers: getLogger() })] });
